export default __webpack_public_path__ + "fed2b58ec9611efd7f0e2a8e91a17442.png";